// ===============================================================================
//
//  This file contains the class containing all the pathnames for surveys
//
// ===============================================================================

export class CreateAndEditSurveyComponentPaths {
    // ===============================================================================

    public static readonly BasePath: string = '/Survey';
    // ===============================================================================

    public static readonly SurveysBasePath: string = '/Surveys';

    // ===============================================================================

    public static readonly NewSurveyPath: string = CreateAndEditSurveyComponentPaths.BasePath + '/New/:startFromSurveyTemplate?/:pageIndexToStartOn?';

    // ===============================================================================

    public static readonly SurveyMatchPath: string = CreateAndEditSurveyComponentPaths.BasePath + '/Match';

    // ===============================================================================

    public static readonly ExistingSurveyPath: string = CreateAndEditSurveyComponentPaths.BasePath + "/:surveyId";

    // ===============================================================================

    public static readonly EditSurveyTemplatePath: string = CreateAndEditSurveyComponentPaths.BasePath + '/Template/:templateId';

    // ===============================================================================

    public static readonly EditSurveyCertificationsRequestPath: string = CreateAndEditSurveyComponentPaths.BasePath + '/Certifications/:requestId?';

    // ===============================================================================

    public static readonly CertificationConsolidationResponseEditorPath: string = CreateAndEditSurveyComponentPaths.BasePath + '/CertificationsResponse/:responseId';

    // ===============================================================================

    public static readonly ManageSurveyTemplatePath: string = CreateAndEditSurveyComponentPaths.BasePath + '/ManageTemplates';
    // ===============================================================================

    public static readonly EditSurveyResponse: string = CreateAndEditSurveyComponentPaths.SurveysBasePath + '/EditSurveyResponse/:responseId';
}